import { StChip } from './Chip.styled'

import type { ChipProps } from './Chip.types'

const Chip = ({ children, ...props }: ChipProps) => {
  return <StChip {...props}>{children}</StChip>
}

export { Chip }
